import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';
import { API_URL } from '../../../config'
import $ from 'jquery'
import Multiselect from 'multiselect-react-dropdown';
class Backoffice extends Component {

    constructor() {
        super();
        this.state = {

            emailID: "",
            pwd: "",
            loginIP: "",
            loginBrowser: "",
            deviceType: "",
            userLocation: "",
            logIsp: "",
            ii: 0,
            actions: [],
            pLogo: "",
            opcarr: [],
            count: 1,
            options: JSON.parse(localStorage.getItem("distlist")),// [{name: 'Option 11', id: 1},{name: 'Option 2', id: 2}],
            empdet:[
                // {
                //     "empCode": "e001",
                //     "empName": "Arpan",
                //     "emailId": "abc@gmail.com",
                //     "phoneNo": "098743211",
                //     "birthPlace": "kolkata",
                //     "address": "kolkata"
                // },
                // {
                //     "empCode": "e002",
                //     "empName": "Souvik",
                //     "emailId": "souvik@gmail.com",
                //     "phoneNo": "098743211",
                //     "birthPlace": "kolkata",
                //     "address": "kolkata"
                // },
                // {
                //     "empCode": "e003",
                //     "empName": "Arpan2",
                //     "emailId": "abc2@gmail.com",
                //     "phoneNo": "098743211",
                //     "birthPlace": "kolkata",
                //     "address": "kolkata"
                // },
                // {
                //     "empCode": "e004",
                //     "empName": "Saikat",
                //     "emailId": "Saikat@gmail.com",
                //     "phoneNo": "098743211",
                //     "birthPlace": "kolkata",
                //     "address": "kolkata"
                // },
                // {
                //     "empCode": "e005",
                //     "empName": "Shakar",
                //     "emailId": "Shakar@gmail.com",
                //     "phoneNo": "098743211",
                //     "birthPlace": "kolkata",
                //     "address": "kolkata"
                // },
                // {
                //     "empCode": "e006",
                //     "empName": "Arpan2",
                //     "emailId": "abc2@gmail.com",
                //     "phoneNo": "098747865",
                //     "birthPlace": "kolkata",
                //     "address": "kolkata"
                // },
                // {
                //     "empCode": "e007",
                //     "empName": "Chandan",
                //     "emailId": "chandan@gmail.com",
                //     "phoneNo": "770943211",
                //     "birthPlace": "Mumbai",
                //     "address": "Mumbai"
                // },
                // {
                //     "empCode": "e008",
                //     "empName": "Mohit",
                //     "emailId": "mohit.kumar@gmail.com",
                //     "phoneNo": "078748911",
                //     "birthPlace": "Patna",
                //     "address": "Patna"
                // },
            ],
            selectedit:[],
            load1:false
        }




    }
    onSelect = (selectedList, selectedItem) => {
       console.log("list=",selectedList)
       console.log("selected item=",selectedItem)
       this.setState({selectedit:selectedList})
    }
    
    onRemove = (selectedList, removedItem) => {
        console.log("list=",selectedList)
        console.log("selected item=",removedItem)
        this.setState({selectedit:selectedList})
    }
     componentDidMount(){  console.clear() 

        console.log(localStorage.getItem("distlist"))
        console.log()
      //  this.setState(options:)

        this.getemp()
       // this.getdist("")
    }
getdist(val) {
    val=""
    this.setState({load1:true})
        // let pwd = document.getElementById("login-password").value
        // let email = document.getElementById("login-email").value
        
        // if (email == '' || pwd == '') {
        //     swal({
        //         title: "OOPS!",
        //         text: "Please enter your email and password!",
        //         icon: "warning",
        //     });

        //     return;
        // }
        //////////////////////////////
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','authorization': localStorage.getItem('token') },
            //  body: JSON.stringify({
            // //    // "email": email,
            // //    // "password": pwd,
            //     "username":email,
            //      "password":pwd
            // })
        };
    
            // let arr=[]
            //         for(let i=0;i<json.length;i++){
            //             console.log("yaay")
            //             let d1={
            //                 name:json[i].customerName,
            //                 id:json[i].customerCode
            //             }
            //             arr.push(d1)
            //             this.setState({options:arr})
            //         }
// $(".loading").removeClass("d-none")
// alert()
        let logourl = API_URL + "/allCustomersWithoutSO?customerName="+val;
        fetch(logourl, requestOptions)
            .then(res => res.json())
            .then(json => {
             //   $(".loading").addClass("d-none")

                let arr=[]
                for(let i=0;i<json.length;i++){
                    console.log("yaay")
                    let d1={
                        name:json[i].customerName,
                        id:json[i].customerCode
                    }
                    console.log(arr)
                    arr.push(d1)
                   
                    //console.log(this.state.options)
                }
                this.setState({options:arr,load1:false})
            //  this.setState({options:json})
                console.log()
                 // this. componentDidMount()

                //  this. componentDidMount()
            })
            .catch( (e) => {

            //    $(".loading").addClass("d-none")

                // swal({
                //     title: "OOPS!",
                //     text: "Please enter correct email and password!",
                //     icon: "warning",
                // });
    
                console.log(e)
            })
        //////////////////////////////

        // localStorage.setItem("email", email);
        // // let data={
        // //     "Email": email,
        // //     "Password": pwd
        // // }
        // let namearr = JSON.parse(localStorage.getItem("PATIENT"))
        // var passed = namearr.filter(function (element, index, array) {
        //     return (element.email == email && element.pass == pwd);
        // });
        // //console.log(name1,name1.email,name1.phone)
        // if (passed.length > 0) {
        //     localStorage.setItem("type", "PATIENT");
        //     window.location.href = "/dashboard";
        // }

        // namearr = JSON.parse(localStorage.getItem("BACKOFFICE"))
        // passed = namearr.filter(function (element, index, array) {
        //     return (element.email == email && element.pass == pwd);
        // });
        // //console.log(name1,name1.email,name1.phone)


        // namearr = JSON.parse(localStorage.getItem("POINTOFSALES"))
        // passed = namearr.filter(function (element, index, array) {
        //     return (element.email == email && element.pass == pwd);
        // });
        // //console.log(name1,name1.email,name1.phone)
        // if (passed.length > 0) {
        //     localStorage.setItem("type", "POINTOFSALES");
        //     window.location.href = "/dashboard2";
        // }

        // namearr = JSON.parse(localStorage.getItem("OPTICIAN"))
        // passed = namearr.filter(function (element, index, array) {
        //     return (element.email == email && element.pass == pwd);
        // });
        // //console.log(name1,name1.email,name1.phone)
        // if (passed.length > 0) {
        //     localStorage.setItem("type", "OPTICIAN");
        //     window.location.href = "/dashboard";
        // }




        // const requestOptions = {
        // const requestOptions = {
        // const requestOptions = {
        //     method: 'POST',
        //    headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
        //     body: JSON.stringify({data})
        // };
        // let logourl ="http://localhost:5000/api/token";
        // fetch(logourl, requestOptions)
        //     .then(res => {  
        //         console.log(res.body);
        //          localStorage.setItem('data',res)
        //   //  window.location.href = "/dashboard2";


        //     })npm 

    }
    getempinfo(empCode) {
        let logourl = API_URL + "/getEmployeeByCode";

    console.log(" empCode " , empCode)
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem('token')
            },
            body: JSON.stringify({
                "empCode": "fcode",
                

            })

        };
        fetch(logourl, requestOptions)
            .then(res => res.json())
            .then(json => {
                this.setState({ empdet: json })
            })
            // .catch((e) => {
            //     swal({
            //         title: "OOPS!",
            //         text: "Something went wong",
            //         icon: "warning",
            //     });

            //     console.log(e)
            // })



    }
    getemp() {
        // let pwd = document.getElementById("login-password").value
        // let email = document.getElementById("login-email").value
        
        // if (email == '' || pwd == '') {
        //     swal({
        //         title: "OOPS!",
        //         text: "Please enter your email and password!",
        //         icon: "warning",
        //     });

        //     return;
        // }
        //////////////////////////////
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json','authorization': localStorage.getItem('token') },
            // body: JSON.stringify({
            //    // "email": email,
            //    // "password": pwd,
            //     "username":email,
            //      "password":pwd
            // })
        };

// $(".loading").removeClass("d-none")
// alert()
        let logourl = API_URL + "/allEmployees";
        fetch(logourl, requestOptions)
            .then(res => res.json())
            .then(json => {
                // $(".loading").addClass("d-none")

                
              this.setState({empdet:json})
                //console.log("s",json=="")
                //   this. componentDidMount()

                //   this. componentDidMount()
            })
            //ee
            .catch( (e) => {

                // $(".loading").addClass("d-none")

                // swal({
                //     title: "OOPS!",
                //     text: "Please enter correct email and password!",
                //     icon: "warning",
                // });
    
                console.log(e)
            })
        //////////////////////////////

    }
    addkoro(){
        this.setState({count:1})
        this.reset()
    }
    submit() {
        let msg=""
        // let data = {
        //     fullname: document.getElementById("basic-icon-default-fullname").value=""
        //     email: document.getElementById("basic-icon-default-email").value,
        //     pass: document.getElementById("basic-icon-default-pass").value,
        //     RPPS: document.getElementById("basic-icon-default-post").value,
        //     docid: document.getElementById("basic-icon-default-salary").value

        // }
        // let wgval=true
        // if(document.getElementById("wg").value=="false"){
        // wgval=false
        // }
        //  /* Validations */
        //  var ret = false;
        //  $("#inputform >  .form-group >  .form-control").each(function () {
        //      if ($(this).val() == "") {
        //          swal({
        //              title: "OOPS!",
        //              text: $(this).parent().find("label").html() + " can not be blank!",
        //              icon: "warning",
        //          });
        //          ret = true;
        //          return false;
        //      }
        //  })
 
        //  if (ret)
        //      return false;
        // //  /* Validations */
       let arr1=[]
       for(let i=0;i<this.state.selectedit.length;i++){
           let ddd={
               distCode:this.state.selectedit[i].id,
               distName:this.state.selectedit[i].name
           }
           arr1.push(ddd)
       }
        let data1 = {
           "empCode":document.getElementById("fcode").value,
            "empName":document.getElementById("lname").value,
            "emailId":document.getElementById("email").value,
            "phoneNo":document.getElementById("PH").value,
            "birthPlace":document.getElementById("DOB").value,
            "address":document.getElementById("PPP").value,
            "empType":document.getElementById("UT").value,
            "empZone": document.getElementById("zone1").value,
            "distributors":arr1
            }
            
        
        // let arr = JSON.parse(localStorage.getItem("doc"))
        // arr.push(data)

        // localStorage.setItem("doc", JSON.stringify(arr))
        //////
        let logourl = API_URL + "/addEmployee";
        if(this.state.count==2){
            msg="Edited Succesfully"
            logourl = API_URL + "/editEmployee";
                    }
                    else{ 
        logourl = API_URL + "/addEmployee";           
         msg = "Added Sucessfully"
                    }
        // if (this.state.count == 1) {
        //     logourl = API_URL + "/optician/add";
        //     msg = "Optician Added successfully"
        // }
        // else {
        //     logourl = API_URL + "/user/edit";
        //     msg = "Optician edited successfully"
        // }
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem('token')
            },
            body: JSON.stringify(data1)
        };

        fetch(logourl, requestOptions)
            .then(res => res.json())
            .then(json => {
               // alert("addd")
                //this.setState({usrdet:json})
                if (1==1) {
                    swal({
                        title: "Done!",
                        text: msg,
                        icon: "success",
                    });
                    document.getElementById("close").click()
                    this.reset()
                    this.getemp()
                  //  this. componentDidMount()
                }
            })
            .catch((e) => {
                swal({
                    title: "OOPS!",
                    text: "Please enter correct email and password!",
                    icon: "warning",
                });

                console.log(e)
            })
        //////

    }
    edit(det){
        this.reset()
        //this.setState({selectedit:selectedList})
    let dist=det.distributors
    console.log(dist)
let arr=[]
    let locdist=JSON.parse(localStorage.getItem("distlist"))
    console.log(locdist[0].id)

    for(let i=0;i<locdist.length;i++){
        if(locdist[i].id=="C00442"){
           // alert("peyechi")
        }
        for(let j=0;j<dist.length;j++){

            if(dist[j].distCode==locdist[i].id){
                console.log("kklk")
arr.push(locdist[i])
            }
        }
    }
    this.setState({selectedit:arr})
    console.log(arr)

        console.log(det)
        this.setState({count:2})
       
        document.getElementById("fcode").setAttribute("disabled","true")
        document.getElementById("fcode").value=det.empCode
        document.getElementById("lname").value=det.empName
        document.getElementById("email").setAttribute("disabled","true")
        document.getElementById("email").value=det.emailId
        document.getElementById("PH").value=det.phoneNo
        document.getElementById("DOB").value=det.birthPlace
        document.getElementById("PPP").value=det.address
        document.getElementById("UT").setAttribute("disabled","true")
        document.getElementById("UT").value="Sales Officer"
        document.getElementById("zone1").value=det.zone
       // document.getElementById ("distributors":arr1)
       
        
    }
  reset(){
    document.getElementById("fcode").removeAttribute("disabled")
    document.getElementById("email").removeAttribute("disabled")
    document.getElementById("UT").removeAttribute("disabled")

    this.setState({selectedit:[]})

    document.getElementById("fcode").value=""
    document.getElementById("lname").value=""
    document.getElementById("email").value=""
    document.getElementById("PH").value=""
    document.getElementById("DOB").value=""
    document.getElementById("PPP").value=""
    document.getElementById("UT").value=""
    document.getElementById("zone1").value=""
  }
    render() {


        return (
         


<>

            

                <div class="content-overlay"></div>
                <div class="header-navbar-shadow"></div>
                <div class="content-wrapper">
                    <div class="content-header row">
                    </div>
                    <div class="content-body ">
                        <section id="basic-datatable">
                            <div class="row">
                                <div class="col">
                                    <div class="card px-0 pb-4">
                                        <div class="card-header border-bottom mr-1">
                                            <div class="head-label">
                                                <h4 class="mb-0">Employee Master</h4>
                                            </div><div class="dt-action-buttons text-right">
                                                <div class="dt-buttons d-inline-flex">
                                                    {/*<div class="btn-group mr-1">
                                                        <button type="button" class="btn btn-outline-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        {window.$language.Export}
                                                        </button>
                                                        <div class="dropdown-menu ">
                                                        <a class="dropdown-item" href="javascript:void(0);"><i class="fas fa-print mr-50"></i>{window.$language.Print}</a>
                                                            <a class="dropdown-item" href="javascript:void(0);"><i class="fas fa-file-csv mr-50"></i>{window.$language.CSV}</a>
                                                            <a class="dropdown-item" href="javascript:void(0);"><i class="fas fa-file-excel mr-50"></i>{window.$language.Excel}</a>
                                                            <a class="dropdown-item" href="javascript:void(0);"><i class="fas fa-file-pdf mr-50"></i>{window.$language.PDF}</a>
                                                        </div>
        </div>*/}
                                                    <button class="btn btn-primary mr-1" tabindex="0" aria-controls="DataTables_Table_0" onClick={()=>this.addkoro()} type="button" data-toggle="modal" data-target="#modals-slide-in">
                                                        <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus mr-50 font-small-4"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>Add Employee</span></button> </div></div></div>

                                        <hr class="my-0" />
                                        <div class="d-flex justify-content-between align-items-center mx-0 row"><div class="col-sm-12 col-md-6">
                                            {/* {<div class="dataTables_length" id="DataTables_Table_0_length"><label>Show 
                                            <select name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" class="custom-select form-control"><option value="7">7</option>
                                        <option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="75">75</option><option value="100">100</option></select></label>
                                        </div>} */}
                                        </div><div class="col-sm-12 col-md-4"><div id="DataTables_Table_0_filter" class="dataTables_filter pt-1"><label class="w-100"><input type="search" onChange={(data1)=>this.getempinfo(data1.target.value)} class="form-control rounded-lg shadow-sm" placeholder="Enter search text" aria-controls="DataTables_Table_0" /></label></div></div></div>
                                        <div class="table-responsive">
                                        <table class="datatables-basic table mt-1 shadow  table-hover">

                                            <thead>
                                                <tr>
                                             
                                                    <th>Employee Code</th>
                                                    <th>Employee Name </th>
                                                    <th>Email </th>
                                                    <th>Phone </th>
                                                   
                                                    <th>STATUS </th>
                                                    <th>Action</th> 

 

                                                </tr>
                                            </thead>
                                            <tbody table-hover-animation>
                                                
                                            {this.state.empdet.map(det => (             <tr>
                                                        <td>{det.empCode}</td>
                                                        <td>{det.empName}</td>
                                                        <td>{det.emailId}</td>
                                                        <td>{det.phoneNo}</td>
                                                        
                                                        
                                                        <td><span class="badge badge-pill badge-light-primary mr-1 status-badge">Active</span></td>
                                                         <td>
                                                        <div class="btn-group" role="group" aria-label="Basic example">
                                                        <button type="button" class="btn btn-outline-secondary"data-toggle="modal" data-target="#modals-slide-in" onClick={() => this.edit(det)}   href="javascript:void(0);"  data-placement="top"  title="Edit"><i class="far fa-edit fa-fw"></i></button>
                                                        <button type="button" class="btn btn-outline-secondary" href="javascript:void(0);"data-toggle="tooltip" data-placement="top" title="Active"><i class="fas fa-flag"></i></button>
                                            </div>
                                                        </td>

                                                    </tr> ))}
                                                
                                            </tbody>
                                        </table>
                                        </div>
                                        <nav aria-label="Page navigation example">
                                        <ul class="pagination mt-3 justify-content-center">
                                        <li class="page-item prev-item"><a class="page-link" href="javascript:void(0);"></a></li>
                                            <li class="page-item active"><a class="page-link" href="javascript:void(0);">1</a></li>
                                            <li class="page-item"><a class="page-link" href="javascript:void(0);">2</a></li>
                                            <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                                            <li class="page-item next-item"><a class="page-link" href="javascript:void(0);"></a></li>
                                        </ul>
                                            </nav>
                                    </div>
                                </div>
                            </div>
                            <div class="modal modal-slide-in fade" id="modals-slide-in">
                                <div class="modal-dialog sidebar-sm w-50">
                                    <form class="add-new-record modal-content pt-0">
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">×</button>
                                        <div class="modal-header mb-1">
                                            <h5 class="modal-title" id="exampleModalLabel">Add Employee</h5>
                                        </div>
                                        <div class="modal-body flex-grow-1" id="inputform">
                                        <div class="form-row mb-1" >
                                            <div class="form-group col-lg-6">
                                                <label class="form-label" for="basic-icon-default-fullname">Employee Code</label>
                                                <input type="text" class="form-control dt-full-name" id="fcode"  placeholder="" aria-label="John Doe" />
                                            </div>
                                            <div class="form-group col-lg-6">
                                                <label class="form-label" for="basic-icon-default-fullname">Employee Name</label>
                                                <input type="text" class="form-control dt-full-name" id="lname" placeholder="" aria-label="John Doe" />
                                            </div>
                                            </div>
                                            <div class="form-row mb-1" >
                                            <div class="form-group col-lg-6">
                                                <label class="form-label" for="basic-icon-default-email">Email</label>
                                                <input type="text" id="email" class="form-control dt-email" placeholder="" aria-label="john.doe@example.com" />

                                            </div>
                                           
                                            <div class="form-group col-lg-6">
                                                <label class="form-label" for="basic-icon-default-post">Phone No.</label>
                                                <input type="number" id="PH" class="form-control dt-post" placeholder="" aria-label="XXXXXXXXXXX" />
                                            </div>
                                            </div>
                                            <div class="form-row mb-1" >
                                            <div class="form-group col-lg-6">
                                                <label class="form-label" for="basic-icon-default-post">Birth Place</label>
                                                <input type="text" id="DOB" class="form-control flatpickr-basic" placeholder="" />
                                            </div>
                                            <div class="form-group col-lg-6">
                                                <label class="form-label" for="basic-icon-default-post">User Zone</label>
                                                <input type="text" id="zone1" class="form-control flatpickr-basic" placeholder="" />
                                            </div>
                                           
                                            <div class="form-group col-lg-6">
                                                <label class="form-label" for="basic-icon-default-email">User Type</label>
                                                
                                                <select name="tax-2-input" id="UT" class="form-control tax-select">
                                                                                <option value="Back Office" selected>Back Office</option>
                                                                                <option value="Sales Officer">Sales Officer</option>

                                                                            </select>
                                            </div>
                                            <div class="form-group col-lg-6">
                                                <label class="form-label" for="basic-icon-default-email">Address</label>
                                                <input type="text" id="PPP" class="form-control dt-email" placeholder="" aria-label="" />

                                            </div>
                                            </div>
                                            

                                            <div class="col-lg-12 mb-2 p-0" data-select2-id="52">
                                            <label>Add Distributor</label>
                                            
                                            <Multiselect
                                                options={this.state.options} // Options to display in the dropdown
                                                selectedValues={this.state.selectedit} // Preselected value to persist in dropdown
                                                onSelect={this.onSelect} // Function will trigger on select event
                                                onRemove={this.onRemove} // Function will trigger on remove event
                                                displayValue="name" // Property name to display in the dropdown options
                                                class="form-control dt-email"

                                                loading={this.state.load1}
                                                loadingMessage="Please wait while all distributors are fetched"
                                                //onSearch={(val)=>this.getdist(val)}
                                            />
                                                                                        
                                            
                                            </div> 
                                      

                                            

                                            <button type="button" class="btn btn-primary data-submit mr-1 btn-page-block-overlay waves-effect  " onClick={() => this.submit()}>Submit</button>
                                            <button type="reset" class="btn btn-outline-secondary" id='close' data-dismiss="modal">Cancel</button>
                                        </div>
                                    </form>
                                </div>
                            </div>

                        </section>
                    </div>
                </div>

</>

        );


    }
}
export default Backoffice